import api from './client';

export type PendenciaStatus = 'aberta' | 'resolvida' | 'concluida';

export interface Pendencia {
  id: number;
  clienteId: number;
  descricao: string;
  criadaPor: { email: string; nome: string; cargo: string | null };
  resolvidaPor: { email: string; nome: string } | null;
  resolvidaEm: string | null;
  concluidaPor: { email: string; nome: string } | null;
  concluidaEm: string | null;
  status: PendenciaStatus;
  createdAt: string;
  updatedAt: string;
}

export async function listarPendencias(clienteId: number, status?: PendenciaStatus): Promise<Pendencia[]> {
  const r = await api.get('/pendencias', { params: { clienteId, ...(status ? { status } : {}) } });
  return r.data.data;
}

export async function criarPendencia(clienteId: number, descricao: string): Promise<Pendencia> {
  const r = await api.post('/pendencias', { clienteId, descricao });
  return r.data.data;
}

// Vendedor marca como resolvida (não conclui). Notifica todos os engenheiros.
export async function resolverPendencia(id: number): Promise<Pendencia> {
  const r = await api.patch(`/pendencias/${id}/resolver`);
  return r.data.data;
}

// Engenharia conclui (de aberta ou resolvida).
export async function concluirPendencia(id: number): Promise<Pendencia> {
  const r = await api.patch(`/pendencias/${id}/concluir`);
  return r.data.data;
}

// Engenharia devolve pro vendedor (reabre).
export async function reabrirPendencia(id: number): Promise<Pendencia> {
  const r = await api.patch(`/pendencias/${id}/reabrir`);
  return r.data.data;
}
